import type { ICalendarFieldIconVariants } from 'BreetAssets';
import type { InputHTMLAttributes } from 'react';

export interface IDatePicker {
	label: string;
	id: string;
	value: Date | null;
	onChange: (date: Date | null) => void;
	errorMessage?: string;
	minDate?: Date;
	maxDate?: Date;
	placeholder?: string;
	required?: boolean;
	disabled?: boolean;
	portalId?: string;
	calendarIconVariant?: ICalendarFieldIconVariants;
}

export type ITriggerProps = {
	label: string;
	id: string;
	errorMessage?: string;
	placeholder?: string;
	disabled?: boolean;
	calendarIconVariant?: ICalendarFieldIconVariants;
} & Partial<Pick<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onClick' | 'onChange' | 'onFocus' | 'onBlur' | 'onKeyDown'>>;

export const ensurePortalNode = (portalId: string) => {
	if (typeof document === 'undefined') return;
	let node = document.getElementById(portalId);
	if (!node) {
		node = document.createElement('div');
		node.id = portalId;
		document.body.appendChild(node);
	}
	node.setAttribute('data-modal-ignore', 'true');
};

export const formatWeekDay = (day: string) => day.substring(0, 3);
